import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "../layout/index";
// import authProtectedRoutes from './allRoutes';

import Services from "../pages/our-services/Services";
import IndividualPage from "../pages/our-services/individual";
import AccountingCompliancePage from "../pages/our-services/accounting";
import AssistancePage from "../pages/our-services/assistance";
import AdvisoryPage from "../pages/our-services/advisory";
import DocumentationPage from "../pages/our-services/documentation";
import DisputePage from "../pages/our-services/dispute";
import DiligencePage from "../pages/our-services/diligence";
import RegistrationPage from "../pages/our-services/registration";
import RestitutionPage from "../pages/our-services/restitution";
import RemovalPage from "../pages/our-services/removal";
import ExemptionPage from "../pages/our-services/exemption";
import PricingPage from "../pages/our-services/pricing";

import AboutUs from "../pages/about-us/index";
import TaxUpdatesHeader from "../pages/tax-updates/header";
import TaxUpdatesDetail from "../pages/tax-updates/detail";
import IndexPage from "../pages/index";
import PageNotFound from "../pages/not-found";
import ServicesLayout from "layout/Services";
import AdminLayout from "layout/Admin";
import DashboardLayout from "layout/Dashboard";
import LoginAdminPage from "pages/admin/LoginPage";
import DashboardPage from "pages/admin/DashboardPage";
import ImageListPage from "pages/admin/ImageListPage";
import CreateArticlePage from "pages/admin/CreateArticlePage";

const getLayout = (children, LayoutComponent) => <LayoutComponent>{children}</LayoutComponent>;

const PrivateRoute = ({ element }) => {
  const token = localStorage.getItem("authToken");
  return token ? element : <Navigate to="/admin" />;
};

const routes = [
  { path: "/", component: <IndexPage /> },
  { path: "/services", component: <Services />, layout: ServicesLayout },
  { path: "/services/individual", component: <IndividualPage />, layout: ServicesLayout },
  { path: "/services/accounting-compliance", component: <AccountingCompliancePage />, layout: ServicesLayout },
  { path: "/services/advisory", component: <AdvisoryPage />, layout: ServicesLayout },
  { path: "/services/assistance", component: <AssistancePage />, layout: ServicesLayout },
  { path: "/services/documentation", component: <DocumentationPage />, layout: ServicesLayout },
  { path: "/services/dispute", component: <DisputePage />, layout: ServicesLayout },
  { path: "/services/diligence", component: <DiligencePage />, layout: ServicesLayout },
  { path: "/services/registration", component: <RegistrationPage />, layout: ServicesLayout },
  { path: "/services/restitution", component: <RestitutionPage />, layout: ServicesLayout },
  { path: "/services/removal", component: <RemovalPage />, layout: ServicesLayout },
  { path: "/services/exempetion", component: <ExemptionPage />, layout: ServicesLayout },
  { path: "/services/pricing", component: <PricingPage />, layout: ServicesLayout },
  { path: "/about-us", component: <AboutUs /> },
  { path: "/tax-updates", component: <TaxUpdatesHeader /> },
  { path: "/tax-updates/detail", component: <TaxUpdatesDetail /> },
  { path: "/admin", component: <LoginAdminPage/>, layout: AdminLayout},
  { path: "/admin/dashboard", component: <DashboardPage/>, layout: DashboardLayout, useMiddleware: true},
  { path: "/admin/image-list", component: <ImageListPage/>, layout: DashboardLayout, useMiddleware: true},
  { path: "/admin/create-article", component: <CreateArticlePage/>, layout: DashboardLayout, useMiddleware: true}
];

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {routes.map((route, idx) => {
            if (route.useMiddleware) {
              return(<Route path={route.path} element={<PrivateRoute element={getLayout(route.component, route.layout ?? Layout)} key={idx} exact={true} />} />);
            } else {
              return (<Route path={route.path} element={getLayout(route.component, route.layout ?? Layout)} key={idx} exact={true} />);
            }
          })}
          <Route
            path="*"
            element={
              <Layout>
                <PageNotFound />
              </Layout>
            }
          />
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
